<template>
  <v-col cols="12" class="pt-1">
    <v-card width="100%" height="100%" class="pt-0">
      <v-col class="pt-0">
        <v-row>
          <v-card color="primaryDark" width="100%" dark class="pa-2 subtitle-1">
            <v-row dense>
              <v-col align-self="center" class="pl-4 pa-0 title">
                Attribute Detail Template Builder
              </v-col>
            </v-row>
          </v-card>
        </v-row>

        <Loading v-if="loadingTemplate"></Loading>
        <v-row v-else class="ma-2 pa-2 cardContent" justify="center">
          <v-col cols="12">
            <v-row shrink dense class="ma-4">
              <v-col cols="4">
                <v-card class="pa-2">
                  <v-img
                    class="v-window-item"
                    src="https://activstoredev.blob.core.windows.net/test/imageplacerholder.png"
                    contain
                    style="height:255px;width:100%"
                  ></v-img>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card class="ma-0 pa-0" min-width="200px">
                  <v-container>
                    <v-col class="pt-0">
                      <v-row>
                        <v-card
                          color="primaryDark"
                          width="100%"
                          dark
                          class="pa-2 subtitle-1"
                        >
                          <v-row dense>
                            <v-col align-self="center" class="pl-4 pa-0">
                              Asset Details
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-row>
                    </v-col>
                    <v-col dense style="padding-top: 0px !important">
                      <v-row
                        class="cardContent title font-weight-medium pa-0 pb-4"
                        dense
                      >
                        <v-col cols="3" dense>Identifier:</v-col>
                      </v-row>
                      <v-row class="cardContent pa-0 pb-4" dense>
                        <v-col cols="3" dense>Category:</v-col>
                      </v-row>
                      <v-row class="cardContent pa-0 pb-4" dense>
                        <v-col cols="3" dense>Name:</v-col>
                      </v-row>
                      <v-row class="cardContent pa-0 pb-4" dense>
                        <v-col cols="3" dense>Description:</v-col>
                      </v-row>
                    </v-col>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-divider class="mx-4"></v-divider>

            <v-row shrink dense class="ma-4">
              <v-col cols="2" align-self="end" class="pl-4 pa-0">
                <v-btn
                  class="ma-0"
                  small
                  dense
                  height="28px"
                  width="210px"
                  :disabled="!CanUserEditAssets()"
                  @click="AddAttributeWidget()"
                >
                  <span class="pa-2 pl-4">Add Attribute Widget</span>
                  <v-icon left light>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <AttributeWidgetTemplate
              :attributeWidgets="attributeWidgets"
              :buildingTemplate="true"
              v-on:widgetDeleted="WidgetDeleted"
              v-on:updateWidget="UpdateWidget"
            ></AttributeWidgetTemplate>
            <v-divider class="mx-4"></v-divider>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <v-dialog
      v-model="showAddWidgetDialog"
      width="500px"
      height="200px"
      v-if="CanUserEditAssets()"
      persistent
    >
      <AddWidget
        :widgetType="addWidgetType"
        v-on:hideAddDialog="CloseAddDialog()"
        v-on:widgetAdded="WidgetAdded"
      ></AddWidget>
    </v-dialog>

    <v-dialog
      v-model="showUpdateDialog"
      width="500px"
      height="200px"
      v-if="CanUserEditAssets()"
      persistent
    >
      <UpdateWidget
        :widget="widgetToUpdate"
        v-on:hideUpdateDialog="CloseUpdateDialog()"
        v-on:widgetUpdated="WidgetUpdated"
      ></UpdateWidget>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import Loading from "../shared/Loading";
import UpdateWidget from "../views/assetDetailTemplates/UpdateWidget.vue";
import AddWidget from "../views/assetDetailTemplates/AddWidget.vue";
import AttributeWidgetTemplate from "../views/assetDetailTemplates/AttributeWidgetTemplate.vue";
import ResourceWidgetTemplate from "../views/assetDetailTemplates/ResourceWidgetTemplate.vue";

export default {
  name: "AssetDetailTemplateBuilder",
  components: {
    Loading,
    UpdateWidget,
    AddWidget,
    AttributeWidgetTemplate,
    ResourceWidgetTemplate,
  },
  props: {},
  mounted: function() {
    this.LoadTemplate();
  },
  computed: {
    ...mapState("assetxpstate", ["section"]),
  },
  data: () => ({
    loadingTemplate: false,
    widgetToUpdate: {},
    showUpdateDialog: false,
    showAddWidgetDialog: false,
    addWidgetType: null,
    attributeWidgets: [],
    resourceWidgets: [],
  }),
  methods: {
    ...mapGetters("authentication", ["CanUserEditAssets", "GetAuthHeaderObj"]),
    ...mapActions("assetxpstate", ["GetSectionAssetTemplate"]),
    LoadTemplate() {
      this.loadingTemplate = true;

      this.GetSectionAssetTemplate(this.section.id).then((response) => {
        this.attributeWidgets = response.data.attributeWidgets;
        this.resourceWidgets = response.data.resourceWidgets;
        this.loadingTemplate = false;
      });
    },
    AddAttributeWidget() {
      (this.addWidgetType = 0), (this.showAddWidgetDialog = true);
    },
    AddResourceWidget() {
      (this.addWidgetType = 3), (this.showAddWidgetDialog = true);
    },
    WidgetAdded(widget) {
      if (widget.widgetType == 0) {
        this.attributeWidgets.push(widget);
      } else if (widget.widgetType == 3) {
        this.resourceWidgets.push(widget);
      }

      this.showAddWidgetDialog = false;
    },
    WidgetUpdated(widget) {
      var index = null;
      if (widget.widgetType == 0) {
        index = this.attributeWidgets.indexOf(this.widgetToUpdate);
        this.attributeWidgets[index] = widget;
      } else if (widget.widgetType == 3) {
        index = this.resourceWidgets.indexOf(this.widgetToUpdate);
        this.resourceWidgets[index] = widget;
      }

      this.showUpdateDialog = false;
      this.LoadTemplate();
    },
    WidgetDeleted(widget) {
      var index = null;

      if (widget.widgetType == 0) {
        index = this.attributeWidgets.indexOf(widget);
        this.attributeWidgets.splice(index, 1);
      } else if (widget.widgetType == 3) {
        index = this.resourceWidgets.indexOf(widget);
        this.resourceWidgets.splice(index, 1);
      }
    },
    UpdateWidget(widget) {
      console.log("updating widget");
      this.showUpdateDialog = true;
      this.widgetToUpdate = widget;
    },
    CloseAddDialog() {
      console.log("close received");
      this.showAddWidgetDialog = false;
    },
    CloseUpdateDialog() {
      console.log("close received");
      this.showUpdateDialog = false;
    },
  },
  watch: {},
};
</script>

<style scoped></style>
